import { KeyValue } from "@core/models/generic/keyValue";

export abstract class GIPPackagingConstants {
  public static readonly PRODUCT_SHEET_BASICINFO: string = 'basicInfo';
  public static readonly PRODUCT_SHEET_PACKAGINGINFO: string = 'packaging';
  public static readonly VIDEOS = 'videos';
  public static readonly DOCUMENTS = 'documents';
  public static readonly FAQS = 'faqs';

  public static readonly APP_NAME: string = 'GIP';
  public static readonly ENVIRONMENT: string = 'GIP.UI';
  public static readonly DEFAULT_MARKET_LANG: string = 'es';
  public static readonly MARKET_LANG_IT: string = 'IT';
  public static readonly PRODUCT_SAVE_INTERVAL_MS: number = 600000;
  public static readonly IMAGESIZE_TAG = '[ImageSize]';

  public static readonly STATUS = {
    INACTIVE: 'Inactive',
    ACTIVE: 'Active',
    DRAFT: 'Draft',
    PUBLISH_ERROR: 'PublishError'
  };

  public static readonly ASIDE_PRODUCT_PAGES: KeyValue<string, any>[] = [
    { key: GIPPackagingConstants.PRODUCT_SHEET_PACKAGINGINFO, value: { routing: 'packaging', order: 1 } },

  ];

  public static readonly ASIDE_HELP_PAGES: KeyValue<string, any>[] = [
    { key: GIPPackagingConstants.VIDEOS, value: { routing: 'videos', order: 1 } },
  ];

  public static readonly ERROR = {
    INVALID_CREDENTIALS: 'Invalid Credentials'
  };
  // public static readonly DATEPICKER_YEARS_DELTA: number = 50;

  public static readonly COMPANY_DEFAULT = {
    MARKET: '724',
    TYPE: 'Publisher',
    DEFAULT_LOCALE: 'ES'
  };

  public static readonly COLORS = {
    GREEN_GIP: '#77DD97',
    DASHBOARD: {
      PIE: {
        DRAFT: '#B9B9B9',
        PUBLISHING: '#FFB414',
        PUBLISHERROR: '#FF0010',
        INACTIVATING: '#000',
        DESCRIPTION_COUNT: '#000'
      },
      BAR: {
        INCIDENCE_PRODUCTS: '#B9B9B9',
        FIA: '#FFF455',
        FII: '#FB8B24',
        FIL: '#6420AA',
        IMI: '#EF4040',
        NVA: '#35374B',
        PNE: '#3ABEF9',
        PUV: '#365E32',
      }

    }
  };
  public static readonly PASSWORD_KEY = '8ad2f71c1b56d440e2a050e2a2dc30e5c7164ec3e0a61f3e8012dd7f3f31b09b';
}
